import React, { useState, createContext, useContext } from 'react';
import { API_BASE } from '../utils/config';
import toast from '../utils/toast';

const AuthContext = createContext(null);

function AuthProvider({ children }) {
  const [token, setToken] = useState(localStorage.getItem('authToken'));
  const [user, setUser] = useState(null);

  const login = (newToken, userInfo) => {
    localStorage.setItem('authToken', newToken);
    setToken(newToken);
    if (userInfo) {
      setUser(userInfo);
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
    }
  };

  const logout = async () => {
    const currentToken = localStorage.getItem('authToken');
    if (currentToken) {
      try {
        await fetch(`${API_BASE}/service/auth/logout`, {
          method: 'POST',
          headers: {
            'X-Auth-Token': currentToken,
            'Content-Type': 'application/json',
          },
        });
      } catch (error) {
        console.log('Logout API call failed:', error);
      }
    }
    localStorage.removeItem('authToken');
    localStorage.removeItem('userInfo');
    setToken(null);
    setUser(null);
  };

  const checkLogin = async () => {
    const currentToken = localStorage.getItem('authToken');
    if (!currentToken) return false;
    try {
      const response = await fetch(`${API_BASE}/service/auth/clogin`, {
        method: 'GET',
        headers: {
          'X-Auth-Token': currentToken,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (data.code === 200 && data.valid) {
        return true;
      } else {
        await logout();
        toast.error(data.msg || '登录已过期，请重新登录');
        return false;
      }
    } catch (err) {
      console.log('检查登录状态失败:', err);
      return true;
    }
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout, checkLogin, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

export { AuthContext, AuthProvider, useAuth };
